import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Stack } from '../../component-stack';
import { Children, forwardRef } from 'react';
/**
 * A component to show a horizontal list of trusted shops icons.
 */
export const TrustedShopsIcons = forwardRef(({ size, icons, ...props }, ref) => (_jsx(Stack, { direction: "horizontal", align: "center", spacing: "small-lg", ...props, ref: ref, children: Children.map(icons.map((icon) => icon({ size })), (icon) => icon) })));
TrustedShopsIcons.displayName = 'TrustedShopsIcons';
